module.exports = __webpack_public_path__ + "img/grupo-folha.3bc2d1d2.svg";